import React from 'react';
import { Button, ButtonGroup, Typography } from '@mui/material';

export default function QuantitySelector({
  children,
  increment,
  decrement,
  disabled = false,
}) {
  return (
    <ButtonGroup
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid black',
        borderRadius: '4px',
        '& .MuiButtonGroup-grouped': {
          border: 'none',
        },
      }}
    >
      <Button
        onClick={() => {
          decrement();
        }}
        disabled={disabled}
        sx={{
          '&:focus': {
            outline: 'none',
          },
          border: 'none',
          '&.Mui-disabled': {
            border: 'none',
          },
        }}
      >
        -
      </Button>
      <Typography
        variant="h5"
        sx={{
          width: '50px',
          textAlign: 'center',
          color: !disabled ? 'black' : 'grey',
          opacity: !disabled ? 1 : 0.5,
        }}
      >
        {children}
      </Typography>
      <Button
        onClick={() => increment()}
        disabled={disabled}
        sx={{
          '&:focus': {
            outline: 'none',
          },
          border: 'none',
          '&.Mui-disabled': {
            border: 'none',
          },
        }}
      >
        +
      </Button>
    </ButtonGroup>
  );
}
